import { ReportType } from "../../../types/types";
import { api } from "../api";

/**
 * getReportWithFiltersResponse - Function that finds on database an especific report and search for its data an then returns the result in a PDF/XSLX file 
 * /reports/{status}/{type}  
 * method POST 
 * @async-function
 */
const getReportWithFiltersResponse = async (token: string, model: ReportType, status: string, type: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {

    const response = await api.post(
        `/reports/${status}/${type}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, { ...model }, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default getReportWithFiltersResponse;